module.exports = __webpack_public_path__ + "static/media/popcorn.99883359.svg";